import {useMutation} from '@github-ui/react-query'
import {verifiedFetch} from '@github-ui/verified-fetch'
import type {OrgPinFormState} from '../types'

interface UseOrgPinMutationOptions {
  /** Base URL of the repository (e.g. "/github/internal-tools") */
  repoUrl: string
}

/**
 * Hook to update organization pin state for a repository.
 * Sends the full form state (all three pin locations) on each toggle.
 */
export function useOrgPinMutation({repoUrl}: UseOrgPinMutationOptions) {
  return useMutation<void, Error, OrgPinFormState>({
    mutationFn: async (formState: OrgPinFormState) => {
      const body = new URLSearchParams({
        'public-profile': formState['public-profile'] ? 'on' : 'off',
        'internal-profile': formState['internal-profile'] ? 'on' : 'off',
        'user-profile': formState['user-profile'] ? 'on' : 'off',
      })

      const response = await verifiedFetch(`${repoUrl}/pin_organization_repo`, {
        method: 'POST',
        headers: {Accept: 'application/json'},
        body,
      })

      if (!response.ok) {
        throw new Error('Failed to update organization pin')
      }
    },
  })
}
